import { useQuery } from '@apollo/client';
// Api
import { GET_TICKETING_LAUNCHED } from 'api/ticketing/queries';
// Types
import { GetTicketingLaunched } from 'api/ticketing/types/GetTicketingLaunched';

type UseTicketingLaunchedResult = {
  /** False while loading or on error, so ticketing never shows before it is confirmed launched. */
  launched: boolean;
  loading: boolean;
};

export const useTicketingLaunched = (): UseTicketingLaunchedResult => {
  const { data, loading } = useQuery<GetTicketingLaunched>(
    GET_TICKETING_LAUNCHED
  );

  return { launched: Boolean(data?.ticketingLaunched), loading };
};
